interface StructuredDataProps {
  data: Record<string, unknown>;
}

export default function StructuredData({ data }: StructuredDataProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '打屁股视频大全',
    url: 'https://dapiguvideo.com',
    description: '精选优质视频内容聚合平台，涵盖亲子教育、影视赏析、搞笑短片、历史文化、动漫游戏与社会热点',
    email: 'contact@dapiguvideo.com',
    telephone: '400-888-6666',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '望京SOHO T3-A座 1208室',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    sameAs: [
      'https://weibo.com/dapiguvideo',
    ],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '打屁股视频大全',
    url: 'https://dapiguvideo.com',
    description: '汇聚打屁股视频相关内容合集，涵盖亲子教育情景、影视片段赏析、搞笑整蛊短片等多种类型',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://dapiguvideo.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: '打屁股视频大全',
      url: 'https://dapiguvideo.com',
    },
  };
}

export function getArticleSchema(article: {
  title: string;
  excerpt: string;
  image: string;
  author: string;
  date: string;
  slug: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: article.image,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.date,
    dateModified: article.date,
    publisher: {
      '@type': 'Organization',
      name: '打屁股视频大全',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://dapiguvideo.com/article/${article.slug}`,
    },
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}